import { VKMiniAppAPI } from '@vkontakte/vk-mini-apps-api';
import connect from '@vkontakte/vk-connect';

export const apiVK = new VKMiniAppAPI();

export const shareMix = (id: number) => {
  return connect.sendPromise("VKWebAppShare", {"link": `https://vk.com/app7244237/#/main/shared-mix/${id}`})
      .then(res => console.log(res))
      .catch(e => console.log(e))
};

export const setLocation = () => {
  console.log(window.location.hash);
  return connect.sendPromise("VKWebAppSetLocation", {"location": `/favorite`})
      .then(res => console.log(res))
      .catch(e => console.log(e));

};

export const setColorStatusBar = () => {
  return connect.sendPromise("VKWebAppSetViewSettings", {"status_bar_style": "dark"})
      .then(res => console.log(res))
      .catch(e => console.log(e))
};

export const VkStorge = {
  saveUUID: (uuid: string) => {
    return connect.sendPromise("VKWebAppStorageSet", { "key": "uuid", "value": uuid })
      .then(data => data)
      .catch(e => console.log(e));
  },
  getUUID() {
    return connect.sendPromise("VKWebAppStorageGet", { "keys": ["uuid"] })
      .then(data => data)
      .catch(e => console.log(e));
  }
};
